import { trackEvent, axiosInstance } from "@hopper-b2b/api";
import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { revokeUserAuthPath } from "./paths";

export const revokeUserAuth = (
  options?: { entity?: string },
  apiConfig?: IApiConfig
): Promise<unknown> =>
  new Promise((resolve, reject) => {
    axiosInstance
      .post(revokeUserAuthPath, options ?? {})
      .then((res) => {
        const responseBody = res.data;
        resolve(responseBody);
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });
